import { Paper, Typography,  Divider, TableContainer, Table, TableHead, TableRow, TableCell,IconButton, TablePagination, Button } from "@mui/material";
import CustomTableBody from "../../utilis/component/CustomTableBody";
import { useNavigate } from "react-router-dom";
import { base, clinicId } from "../../constants";
import moduleRoutes from "../../routes/moduleRouteList";
import SettingsRouteList from "../routeList";
import EditIcon from "@mui/icons-material/Edit";
import { useQuery } from "react-query";
import { MasterDataListType } from "./types";
import { getMasterTableData } from "./Service";
import { useState } from "react";
import { SearchParamsType } from "../../Masters/TemplateMaster/types";
import moment from "moment";


function ExpenseManager() {
    const title="Expense Manager"
    const navigate=useNavigate()
      const [searchParams, setSearchParams] = useState<SearchParamsType>({
        pageNumber: 0,
        pageSize: 25,
        sortField: "",
        sortOrder: "",
        filter:{
           searchText: "",
           status: 2,
        },
        clinicId: clinicId, // Assuming clinicId is 1 for this example
      });

     const handleNavigateClick = (data?:any) => {
            navigate(
                `${base}${moduleRoutes.mainRoute}/${moduleRoutes.settings}/${SettingsRouteList.expenseManager}/${SettingsRouteList.addOrEdit}`,
                { state: { data: data || null } }
            );
        };
     const {
            data: tableData,
            isLoading: tableDataLoading,
        } = useQuery(
            ["",searchParams],
            ()=>getMasterTableData(searchParams),
            {
                refetchOnWindowFocus: false,
            }
        );  


        const handleChangePage = (
            _: React.MouseEvent<HTMLButtonElement> | null,
            pageNumber: number
          ) => {
            setSearchParams((prev) => ({
              ...prev,
              pageNumber,
            }));
          };
        
          const handleChangeRowsPerPage = (
            event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
          ) => {
            setSearchParams((prev) => ({
              ...prev,
              pageNumber: 0,
              pageSize: parseInt(event.target.value, 10),
            }));
          };

  return (
          <Paper className="m-3 mt-6">
                <div className="flex justify-between p-3">
                    <div className="flex gap-2">
                        <Typography variant="h6" color={"default"}>
                          {title} List
                        </Typography>
                    </div>
                    <div className="flex gap-2">
                                <Button
                                  onClick={() => {
                                    handleNavigateClick();
                                  }}
                                >
                                  new {title}
                                </Button>
                              </div>
                </div>
                <Divider />
                <div className="">
                    
                    <TableContainer className="border">
                        <Table stickyHeader size="small">
                            <TableHead>
                                <TableRow>
                                    {headings.map((heading) => (
                                        <TableCell key={heading} className="font-bold">
                                            {heading}
                                        </TableCell>
                                    ))}
                                    <TableCell className="font-bold">Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <CustomTableBody
                                alert={"No data"}
                                dataLoading={tableDataLoading}
                                isData={Boolean(tableData?.response?.totalCount)}
                                totalSpan={{
                                    row: 4,
                                    col: headings.length+1,
                                }}
                            >
                                {tableData?.response?.expenceDto?.map((tableItem:MasterDataListType, index:number) => (
                                    <TableRow key={`${title}-${index}`}>
                                        <TableCell>{index+1}</TableCell>
                                        <TableCell>{tableItem?.expenseReportDate ? moment(tableItem.expenseReportDate).format("DD-MM-YYYY") : ""}</TableCell>
                                         <TableCell> {tableItem?.amount}  </TableCell>
                                         <TableCell> {tableItem?.catName}  </TableCell>
                                         <TableCell> {tableItem?.item}  </TableCell>
                                        <TableCell>
                                            <div className="flex gap-2">
                                                <IconButton
                                                    color="primary"
                                                    onClick={() => {
                                                        handleNavigateClick(tableItem);
                                                    }}
                                                >
                                                    <EditIcon/>
                                                </IconButton>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </CustomTableBody>
                        </Table>
                         <div className="flex justify-end">
                                      <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component={"div"}
                                        count={tableData?.response?.totalCount || 0}
                                        rowsPerPage={searchParams.pageSize}
                                        page={searchParams.pageNumber}
                                        sx={{ border: 0 }}
                                        slotProps={{
                                          select: {
                                            inputProps: {
                                              "aria-label": "rows per page",
                                            },
                                            native: true,
                                          },
                                        }}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        // ActionsComponent={TablePaginationActions}
                                      />
                                    </div>
                    </TableContainer>
                </div>
            </Paper>
  )
}

export default ExpenseManager

const headings=[
    "SL No",
    "Expense Report Date",
    "Amount",
    "Category Name",
    "Description"
]

